module.exports = __webpack_public_path__ + "img/logo.b3502f80.svg";